/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_cognito_identity_pool_id": "eu-north-1:3322234b-d9f8-4784-8b66-24fd380eeaa9",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_kkkdVAs90",
    "aws_user_pools_web_client_id": "v7jjcgec53hq2m49dh55j5sgb",
    "oauth": {
        "domain": "adly-crm-auth.auth.eu-north-1.amazoncognito.com",
        "scope": ["email", "openid", "profile"],
        "redirectSignIn": "http://localhost:3000/",
        "redirectSignOut": "http://localhost:3000/",
        "responseType": "code"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": ["MicrosoftOutlook"],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
